import Vue from 'vue'
let baseUrl = process.env.VUE_APP_API_IDP_URL;
if(baseUrl.substring(baseUrl.length - 1) == "/")
    baseUrl = baseUrl.substring(0, baseUrl.length - 1);

baseUrl = `${baseUrl}/object`;
export default{
    async listar(){
        return await Vue.prototype.$httpJson.get(baseUrl);
    },    
    async listarPorId(id){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/${encodeURI(id)}`);
    },
    async listarPorTipoObjeto(idTipoObjeto){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/object-type/${encodeURI(idTipoObjeto)}`);
    },    
    async inserir(model){
        return await Vue.prototype.$httpJson.post(baseUrl, model);
    },
    async alterar(id, model){
        return await Vue.prototype.$httpJson.put(`${baseUrl}/${encodeURI(id)}`, model);
    }     
}